// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Dependientes.module.css */

.Dependientes_subtitle__LeyLs {
  font-size: 14px;
  color: #667085;
  margin-bottom: 20px;
  margin-top: -12px;
}

.Dependientes_twoCol__ZgxFH {
  display: grid;
  grid-template-columns: 1fr 300px;
  gap: 16px;
  align-items: start;
}

/* Lista */
.Dependientes_depList__xjpND {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.Dependientes_depCard__j6nKZ {
  display: flex;
  align-items: center;
  gap: 14px;
  background: #fff;
  border-radius: 14px;
  padding: 16px 18px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.06);
  cursor: pointer;
  border: 1.5px solid transparent;
  transition:
    border-color 0.15s,
    background 0.15s;
}

.Dependientes_depCard__j6nKZ:hover {
  border-color: #2db899;
}
.Dependientes_depCardActive__gRHKS {
  border-color: #2db899;
  background: #f0fdf9;
}

.Dependientes_depAvatar__hRHla {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  color: #fff;
  font-size: 15px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.Dependientes_depInfo__wIEO4 {
  flex: 1 1;
}
.Dependientes_depName__if4gw {
  font-size: 14px;
  font-weight: 700;
  color: #344054;
  margin-bottom: 3px;
}
.Dependientes_depMeta__2xQdd {
  font-size: 12px;
  color: #98a2b3;
}

.Dependientes_depStats__aD0xq {
  text-align: center;
}
.Dependientes_depStatVal__5lNVG {
  font-size: 1.4rem;
  font-weight: 800;
  color: #1a3a5c;
  line-height: 1;
}
.Dependientes_depStatLbl__zbZqI {
  font-size: 10px;
  color: #98a2b3;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* Agregar card */
.Dependientes_addCard__f5d\\+d {
  display: flex;
  align-items: center;
  gap: 14px;
  background: #fff;
  border-radius: 14px;
  padding: 16px 18px;
  border: 1.5px dashed #d0d5dd;
  cursor: pointer;
  text-decoration: none;
  transition:
    border-color 0.15s,
    background 0.15s;
}

.Dependientes_addCard__f5d\\+d:hover {
  border-color: #2db899;
  background: #f0fdf9;
}

.Dependientes_addIcon__Y7UlB {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: #f0f4f8;
  color: #2db899;
  font-size: 22px;
  font-weight: 400;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.Dependientes_addTitle__PfnkG {
  font-size: 14px;
  font-weight: 700;
  color: #2db899;
  margin-bottom: 2px;
}
.Dependientes_addSub__Hwvqd {
  font-size: 12px;
  color: #98a2b3;
}

/* Detalle */
.Dependientes_detail__\\+W8UU {
  display: flex;
  flex-direction: column;
}

.Dependientes_detailTop__F9qQG {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 20px;
  padding-bottom: 16px;
  border-bottom: 1px solid #f2f4f7;
}

.Dependientes_detailAvatar__BD2ZF {
  width: 52px;
  height: 52px;
  border-radius: 50%;
  color: #fff;
  font-size: 15px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.Dependientes_detailName__4UsBH {
  font-size: 16px;
  font-weight: 800;
  color: #1a3a5c;
  margin-bottom: 3px;
}
.Dependientes_detailRel__Wm64z {
  font-size: 13px;
  color: #667085;
}

.Dependientes_detailRow__LZOmb {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 0;
  border-bottom: 1px solid #f2f4f7;
  font-size: 13px;
}

.Dependientes_detailRow__LZOmb span {
  color: #98a2b3;
  font-weight: 600;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.Dependientes_detailRow__LZOmb strong {
  color: #344054;
  font-weight: 600;
}

.Dependientes_detailActions__s\\+mx8 {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 20px;
}

.Dependientes_btnNuevaCita__HAEN8 {
  width: 100%;
  padding: 11px;
  background: #2db899;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  text-align: center;
  text-decoration: none;
  transition: background 0.2s;
  display: block;
}

.Dependientes_btnNuevaCita__HAEN8:hover {
  background: #25a085;
}

.Dependientes_btnEliminar__t4tPk {
  width: 100%;
  padding: 10px;
  background: transparent;
  border: 1.5px solid #fda29b;
  border-radius: 8px;
  color: #d92d20;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s;
}

.Dependientes_btnEliminar__t4tPk:hover {
  background: #fff1f0;
}

@media (max-width: 860px) {
  .Dependientes_twoCol__ZgxFH {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Dependientes/Dependientes.module.css"],"names":[],"mappings":"AAAA,4BAA4B;;AAE5B;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,kBAAkB;AACpB;;AAEA,UAAU;AACV;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,yCAAyC;EACzC,eAAe;EACf,+BAA+B;EAC/B;;oBAEkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,SAAO;AACT;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;AACA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,4BAA4B;EAC5B,eAAe;EACf,qBAAqB;EACrB;;oBAEkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,qBAAqB;EACrB,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,2BAA2B;EAC3B,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF","sourcesContent":["/* Dependientes.module.css */\n\n.subtitle {\n  font-size: 14px;\n  color: #667085;\n  margin-bottom: 20px;\n  margin-top: -12px;\n}\n\n.twoCol {\n  display: grid;\n  grid-template-columns: 1fr 300px;\n  gap: 16px;\n  align-items: start;\n}\n\n/* Lista */\n.depList {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.depCard {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  background: #fff;\n  border-radius: 14px;\n  padding: 16px 18px;\n  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.06);\n  cursor: pointer;\n  border: 1.5px solid transparent;\n  transition:\n    border-color 0.15s,\n    background 0.15s;\n}\n\n.depCard:hover {\n  border-color: #2db899;\n}\n.depCardActive {\n  border-color: #2db899;\n  background: #f0fdf9;\n}\n\n.depAvatar {\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  color: #fff;\n  font-size: 15px;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.depInfo {\n  flex: 1;\n}\n.depName {\n  font-size: 14px;\n  font-weight: 700;\n  color: #344054;\n  margin-bottom: 3px;\n}\n.depMeta {\n  font-size: 12px;\n  color: #98a2b3;\n}\n\n.depStats {\n  text-align: center;\n}\n.depStatVal {\n  font-size: 1.4rem;\n  font-weight: 800;\n  color: #1a3a5c;\n  line-height: 1;\n}\n.depStatLbl {\n  font-size: 10px;\n  color: #98a2b3;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n/* Agregar card */\n.addCard {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  background: #fff;\n  border-radius: 14px;\n  padding: 16px 18px;\n  border: 1.5px dashed #d0d5dd;\n  cursor: pointer;\n  text-decoration: none;\n  transition:\n    border-color 0.15s,\n    background 0.15s;\n}\n\n.addCard:hover {\n  border-color: #2db899;\n  background: #f0fdf9;\n}\n\n.addIcon {\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  background: #f0f4f8;\n  color: #2db899;\n  font-size: 22px;\n  font-weight: 400;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.addTitle {\n  font-size: 14px;\n  font-weight: 700;\n  color: #2db899;\n  margin-bottom: 2px;\n}\n.addSub {\n  font-size: 12px;\n  color: #98a2b3;\n}\n\n/* Detalle */\n.detail {\n  display: flex;\n  flex-direction: column;\n}\n\n.detailTop {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  margin-bottom: 20px;\n  padding-bottom: 16px;\n  border-bottom: 1px solid #f2f4f7;\n}\n\n.detailAvatar {\n  width: 52px;\n  height: 52px;\n  border-radius: 50%;\n  color: #fff;\n  font-size: 15px;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.detailName {\n  font-size: 16px;\n  font-weight: 800;\n  color: #1a3a5c;\n  margin-bottom: 3px;\n}\n.detailRel {\n  font-size: 13px;\n  color: #667085;\n}\n\n.detailRow {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 0;\n  border-bottom: 1px solid #f2f4f7;\n  font-size: 13px;\n}\n\n.detailRow span {\n  color: #98a2b3;\n  font-weight: 600;\n  font-size: 11px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n.detailRow strong {\n  color: #344054;\n  font-weight: 600;\n}\n\n.detailActions {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-top: 20px;\n}\n\n.btnNuevaCita {\n  width: 100%;\n  padding: 11px;\n  background: #2db899;\n  color: #fff;\n  border: none;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 700;\n  cursor: pointer;\n  text-align: center;\n  text-decoration: none;\n  transition: background 0.2s;\n  display: block;\n}\n\n.btnNuevaCita:hover {\n  background: #25a085;\n}\n\n.btnEliminar {\n  width: 100%;\n  padding: 10px;\n  background: transparent;\n  border: 1.5px solid #fda29b;\n  border-radius: 8px;\n  color: #d92d20;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n\n.btnEliminar:hover {\n  background: #fff1f0;\n}\n\n@media (max-width: 860px) {\n  .twoCol {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"subtitle": `Dependientes_subtitle__LeyLs`,
	"twoCol": `Dependientes_twoCol__ZgxFH`,
	"depList": `Dependientes_depList__xjpND`,
	"depCard": `Dependientes_depCard__j6nKZ`,
	"depCardActive": `Dependientes_depCardActive__gRHKS`,
	"depAvatar": `Dependientes_depAvatar__hRHla`,
	"depInfo": `Dependientes_depInfo__wIEO4`,
	"depName": `Dependientes_depName__if4gw`,
	"depMeta": `Dependientes_depMeta__2xQdd`,
	"depStats": `Dependientes_depStats__aD0xq`,
	"depStatVal": `Dependientes_depStatVal__5lNVG`,
	"depStatLbl": `Dependientes_depStatLbl__zbZqI`,
	"addCard": `Dependientes_addCard__f5d+d`,
	"addIcon": `Dependientes_addIcon__Y7UlB`,
	"addTitle": `Dependientes_addTitle__PfnkG`,
	"addSub": `Dependientes_addSub__Hwvqd`,
	"detail": `Dependientes_detail__+W8UU`,
	"detailTop": `Dependientes_detailTop__F9qQG`,
	"detailAvatar": `Dependientes_detailAvatar__BD2ZF`,
	"detailName": `Dependientes_detailName__4UsBH`,
	"detailRel": `Dependientes_detailRel__Wm64z`,
	"detailRow": `Dependientes_detailRow__LZOmb`,
	"detailActions": `Dependientes_detailActions__s+mx8`,
	"btnNuevaCita": `Dependientes_btnNuevaCita__HAEN8`,
	"btnEliminar": `Dependientes_btnEliminar__t4tPk`
};
export default ___CSS_LOADER_EXPORT___;
